import { render, staticRenderFns } from "./OcrFileSelect.vue?vue&type=template&id=ff6cf93e&scoped=true"
import script from "./OcrFileSelect.vue?vue&type=script&lang=js"
export * from "./OcrFileSelect.vue?vue&type=script&lang=js"
import style0 from "./OcrFileSelect.vue?vue&type=style&index=0&id=ff6cf93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6cf93e",
  null
  
)

export default component.exports